module.exports = __webpack_public_path__ + "img/family.a1145d78.png";